export default __webpack_public_path__ + "static/media/home-menu-icon.92a6aeb7.svg";